export const Error = {
    CREAT_CHECKOUT_CARTID_MISSING: "Error: Can't creat checkout, Missing cartId",
    CREAT_CHECKOUT_CART_DATA_MISSING: "Error: Can't creat checkout, Missing cart Data",
    CREAT_CHECKOUT_COUNTRY_CODE_MISSING: "Error: Can't creat checkout, Missing Country Code",
    UPDATING_SHIPPING_METHOD_CHECKOUTID_MISSING: "Error: Can't update checkout shipping method, Missing checkoutId",

}
